import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { getAllAdminEmails } from "../../../api/users";

interface MigrateOfferModalProps {
    onClose: () => void;
    offer_id: number;
    onConfirm: (email: string) => Promise<void>;
}

export default function MigrateOfferModal({
    onClose,
    offer_id,
    onConfirm,
}: MigrateOfferModalProps) {
    const [users, setUsers] = useState<string[]>([]);
    const [selectedUser, setSelectedUser] = useState<string>("")

    useEffect(() => {
        const fetchAdminEmails = async () => {
            try {
                const result = await getAllAdminEmails();
                setUsers(result);
            } catch (error: any) {
                toast.error(error?.message || "Failed to fetch admin emails");
            }
        }
        fetchAdminEmails();
    }, [])

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 w-96 shadow-lg max-h-[90vh] overflow-y-auto">
                <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                    Migrating Offer {offer_id}
                </h2>

                <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    className="w-full mb-4 p-2 border rounded"
                >
                    <option value="">Select user</option>
                    {users.map((u) => (
                        <option key={u} value={u}>
                            {u}
                        </option>
                    ))}
                </select>

                <p className="mb-4 text-gray-700 dark:text-gray-300">
                    Are you sure you want to migrate it?
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(selectedUser)}
                        className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
                    >
                        Migrate
                    </button>
                </div>
            </div>
        </div>
    );
}
